import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { UnitProvider } from './contexts/UnitContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import WelcomePage from './features/WelcomePage';
import { AppRouter } from './components/layout';
import { LabelingFormProvider } from './features/labeling/LabelingFormContext';
import { AuthProvider } from './contexts/AuthContext';
import { LoadingProvider, TopLoadingBar } from './components/widgets/loading';
import { ProductsProvider } from './features/shipping-calculator/utils/products-context';

import { GlobalAuthModals } from './components/auth/AuthModal';
import { migrateLegacyStorage } from './utils/authUtils';

// Run migration once on app load
migrateLegacyStorage();

function App() {
  return (
    <div>
      <UnitProvider>
        <CurrencyProvider>
          <LabelingFormProvider>
            <AuthProvider>
              <LoadingProvider>
                <ProductsProvider>
                  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                    <TopLoadingBar />
                    <Routes>
                      {/* About page without sidebar */}
                      <Route path="/about" element={<WelcomePage />} />

                      {/* All routes are handled by AppRouter (Sidebar + AppRouter) */}
                      <Route path="/" element={<AppRouter />} />
                      <Route path="/shipping" element={<AppRouter />} />
                      <Route path="/dropshipping/*" element={<AppRouter />} />
                      <Route path="/products" element={<AppRouter />} />
                      <Route path="/erp" element={<AppRouter />} />
                      <Route path="/erp/*" element={<AppRouter />} />
                      <Route path="/admin/*" element={<AppRouter />} />

                      {/* Catch-all for all other app routes (labeling, account, etc) */}
                      <Route path="*" element={<AppRouter />} />
                    </Routes>
                    <GlobalAuthModals />
                  </BrowserRouter>
                </ProductsProvider>
              </LoadingProvider>
            </AuthProvider>
          </LabelingFormProvider>
        </CurrencyProvider>
      </UnitProvider>
    </div>
  );
}

export default App;
